module.exports = __WEBPACK_EXTERNAL_MODULE__6640__;